import { Card, CardContent, Button, Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

type FilterField = {
  name: string
  label: string
  type?: 'text' | 'number' | 'date' | 'select'
  placeholder?: string
  options?: Array<{ label: string; value: string }>
}

type Props = {
    searchLabel?: string;
    search?: string;
    handleReset: () => void;
    setSearchKeyword?: (e: string) => void;
    filters?: FilterField[];
    filterValues?: Record<string, any>;
    onFilterChange?: (filterName: string, value: any) => void;
}

const BordFilterCard = ({ 
  searchLabel, 
  search, 
  handleReset, 
  setSearchKeyword,
  filters,
  filterValues = {},
  onFilterChange
}: Props) => {
  // Use provided filters or default to single search field
  const fieldsToRender = filters || (searchLabel ? [{
    name: 'search',
    label: searchLabel,
    type: 'text',
    placeholder: 'Search...'
  }] : [])

  return (
    <Card
      sx={{
        height: '100%',
        cursor: 'pointer',
        boxShadow: 2,
        padding: 2,
        mb: 3,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 4,
        },
      }}
    >
      <CardContent>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-12 items-end">
          {fieldsToRender.map((field) => {
            // Render Select Input
            if (field.type === 'select') {
              return (
                <div key={field.name} className="col-span-1 md:col-span-4">
                  <FormControl fullWidth size="small">
                    <InputLabel>{field.label}</InputLabel>
                    <Select
                      label={field.label}
                      value={filterValues[field.name] || ''}
                      onChange={(e) => {
                        if (onFilterChange) {
                          onFilterChange(field.name, e.target.value)
                        }
                      }}
                    >
                      {field.options?.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )
            }

            // Render Text/Number Input
            return (
              <div key={field.name} className="col-span-1 md:col-span-4">
                <label className="block mb-1 text-sm font-medium text-gray-700">
                  {field.label}
                </label>
                <input
                  type={field.type === 'number' ? 'number' : 'text'}
                  value={field.name === 'search' ? search : filterValues[field.name] || ''}
                  onChange={(e) => {
                    if (field.name === 'search' && setSearchKeyword) {
                      setSearchKeyword(e.target.value)
                    } else if (onFilterChange) {
                      onFilterChange(field.name, field.type === 'number' ? Number(e.target.value) : e.target.value)
                    }
                  }}
                  placeholder={field.placeholder || "Search..."}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#026730] focus:border-transparent"
                />
              </div>
            )
          })}

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="col-span-1 md:col-span-4 flex justify-center md:justify-start">
              <Button
                variant="outlined"
                size="small"
                onClick={handleReset}
                sx={{
                  borderRadius: 2,
                  width: '113px',
                }}
              >
                Reset
              </Button>
            </div>
          </LocalizationProvider>
        </div>
      </CardContent>
    </Card>
  )
}

export default BordFilterCard